import { useLogout, useMyRoles, useAPI4State } from "@poolzfinance/api4"
import { useEffect, useState } from "react"

const Logout: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (props) => {
  const { data: myRolesData, loading: myRoleLoading, refetch } = useMyRoles()
  const [logout, { data: logoutData, loading: logoutLoading }] = useLogout()
  const [myRole, setMyRole] = useState<string>()

  const {
    apiState: [State, setState]
  } = useAPI4State()

  const { userDenied } = State

  const buttonHandler = async () => {
    if (myRole) {
      setState((prev) => ({ ...prev, userDenied: true }))
      return logout()
    }
    if (userDenied) setState((prev) => ({ ...prev, userDenied: false, privatTokenStatus: 0 }))
    refetch()
  }
  useEffect(() => {
    if (myRolesData) {
      setMyRole(myRolesData.myRoles[0])
    }
  }, [myRolesData])

  useEffect(() => {
    if (logoutData?.logout) {
      setMyRole(undefined)
    }
  }, [logoutData])

  return (
    <button disabled={myRoleLoading || logoutLoading} id="logout-btn" onClick={buttonHandler} {...props}>
      {myRole ? "Logout" : "Login"}
    </button>
  )
}

export default Logout
